import React from 'react';
import ParallaxSection from './ParallaxSection';
import { Accordion, AccordionItem } from './Accordion';
import { useScrollToContact } from '../hooks/useScrollToContact';

const Training: React.FC = () => {
  const scrollToContact = useScrollToContact();

  return (
    <ParallaxSection
      id="ausbildung"
      backgroundImage="/images/Flugsportverein_Bilder_5.jpg"
    >
      <div>
        <div className="lg:text-center">
          <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">Ausbildung</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Ihre Flugausbildung bei uns
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto mb-10">
            Wir bieten professionelle Ausbildungen für verschiedene Fluglizenzen an.
            Lernen Sie bei erfahrenen Fluglehrern und starten Sie Ihre Karriere in der Luftfahrt.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Segelflug Training (Left Side) */}
          <div className="bg-white shadow overflow-hidden rounded-lg">
            <div className="px-4 py-5 sm:px-6 bg-gray-50">
              <h3 className="text-lg leading-6 font-medium text-gray-900">Segelflugausbildung (GPL)</h3>
            </div>
            <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
              <p className="mb-4">
                Erfahren Sie mehr über die Ausbildung zum Segelflugpiloten und den Erwerb des Luftfahrerscheins GPL.
              </p>

              <Accordion>
                <AccordionItem title="Voraussetzungen und Ablauf">
                  <div>
                    <h4 className="font-bold">Voraussetzungen:</h4>
                    <p className="py-1">Medizinische Tauglichkeit</p>
                    <p className="py-1">Mindestalter 14 Jahre</p>

                    <h4 className="font-bold mt-3">Ablauf der Ausbildung:</h4>
                    <p className="py-1">Theoretische Ausbildung (60 Stunden im Winter, Themen wie Aerodynamik, Navigation)</p>
                    <p className="py-1">Praktische Ausbildung (60 Flüge mit Fluglehrer, erster Alleinflug)</p>
                  </div>
                </AccordionItem>

                <AccordionItem title="Prüfungen, Dauer und Weiteres">
                  <div>
                    <h4 className="font-bold">Prüfungen und Abschluss:</h4>
                    <p className="py-1">Theoretische/praktische Prüfung bei der Bezirksregierung</p>
                    <p className="py-1">50 km Überlandflug</p>

                    <h4 className="font-bold mt-3">Dauer der Ausbildung:</h4>
                    <p className="py-1">2–3 Jahre</p>
                    <p className="py-1">Flugsaison März–Oktober</p>

                    <h4 className="font-bold mt-3">Weitere Aspekte:</h4>
                    <p className="py-1">Segelflug als Mannschaftssport</p>
                    <p className="py-1">Beiträge/Wartungsdienste</p>
                    <p className="py-1">Fliegen bei Schönwetter</p>
                  </div>
                </AccordionItem>
              </Accordion>
            </div>
          </div>

          {/* SPL Training (Right Side) */}
          <div className="bg-white shadow overflow-hidden rounded-lg">
            <div className="px-4 py-5 sm:px-6 bg-gray-50">
              <h3 className="text-lg leading-6 font-medium text-gray-900">Sportpilotenlizenz (SPL) für Ultraleichtflugzeuge</h3>
            </div>
            <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
              <p className="mb-4">
                Erfahren Sie, wie Sie die Sportpilotenlizenz (SPL) erwerben und Ultraleichtflugzeuge fliegen können.
              </p>

              <Accordion>
                <AccordionItem title="Voraussetzungen und Ablauf">
                  <div>
                    <h4 className="font-bold">Voraussetzungen:</h4>
                    <p className="py-1">Medizinische Tauglichkeit (Medical LAPL/Klasse 2)</p>
                    <p className="py-1">Mindestalter 16 Jahre</p>
                    <p className="py-1">Soft Skills</p>
                    <p className="py-1">Sofortmaßnahmen-Unterricht</p>

                    <h4 className="font-bold mt-3">Ablauf der Ausbildung:</h4>
                    <p className="py-1">Theoretische Ausbildung (60 Stunden, Themen wie Luftrecht, Navigation)</p>
                    <p className="py-1">Praktische Ausbildung (30 Flugstunden, 5 Alleinflug)</p>
                    <p className="py-1">Funksprechzeugnis (BZF II/I)</p>
                  </div>
                </AccordionItem>

                <AccordionItem title="Prüfungen, Dauer und Weiteres">
                  <div>
                    <h4 className="font-bold">Nach der Ausbildung:</h4>
                    <p className="py-1">Praktische Prüfung</p>
                    <p className="py-1">Frist von 24 Monaten nach Theorieprüfung</p>

                    <h4 className="font-bold mt-3">Weitere Punkte:</h4>
                    <p className="py-1">Nationale Lizenz</p>
                    <p className="py-1">Maximales Abfluggewicht 600 kg</p>
                    <p className="py-1">Kosten 3.500–5.000 Euro, je nach Lernfortschritt</p>
                    <p className="py-1">Mind. 6 Flugstunden/Jahr</p>
                  </div>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center">
          <a
            href="#kontakt"
            onClick={scrollToContact}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
          >
            Starten Sie Ihre Ausbildung noch heute! Kontaktieren Sie uns.
          </a>
        </div>
      </div>
    </ParallaxSection>
  );
};

export default Training;
